import { requestApi } from './Api';

export const updateAddress = async (navigate, address) => {
  const res = await requestApi({
    navigate,
    url: '/api/address/patch',
    params: {
      loadedAddress: address
    }
  });
  return res;
};
